import { useEffect, useState } from "react";
import { ScreenServices } from "../utils/screen-services";

const useIsMobileView = () => {
  const [isMobileView, setMobileViewActive] = useState<boolean>(false);

  useEffect(() => {
    setMobileViewActive(ScreenServices.isMobileBreakpoint());
    window.addEventListener("resize", () => setMobileViewActive(ScreenServices.isMobileBreakpoint()));
    return removeEventListener("resize", () => setMobileViewActive(ScreenServices.isMobileBreakpoint()));
  }, []);

  return {
    isMobileView,
    setMobileViewActive,
  };
};

export default useIsMobileView;
